<template>
	<BaseContenedor>
		<BaseBuscar v-model="filter">
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				:disabled="personal.length === 0"
				style-button="danger"
				style-class="right floated"
				@click="onEliminar"
			>
				<i class="trash icon"></i>
				Eliminar
			</BaseButton>
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				style-class="orange right floated"
				@click="clickEliminarTodosAspirantesPersonal"
			>
				<i class="user times icon"></i>
				Desasociar Aspirantes
			</BaseButton>
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				style-class="right floated"
				style-button="success"
				@click="clickAsignarAspirantes"
			>
				<i class="plus icon"></i>
				Asociar Aspirantes
			</BaseButton>
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				style-class="right floated positive"
				@click="clickImportar"
			>
				<i class="plus icon"></i>
				Importar
			</BaseButton>
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				style-button="primary"
				style-class="right floated"
				@click="toggleModalAgregar"
			>
				<i class="plus icon"></i>
				Agregar
			</BaseButton>
		</BaseBuscar>

		<BaseModalArchivo
			ref="modal-archivo"
			v-model="files"
			:titulo="
				`Importar ${asignarAspirantes ? 'aspirantes a personal' : 'personal'}`
			"
			:plantilla-descripcion="
				`Descargue el formato CSV para ${
					asignarAspirantes
						? 'asignar aspirantes al personal'
						: 'agregar nuevo personal'
				}`
			"
			:plantilla="asignarAspirantes ? plantillaAsignarAspirantes : plantilla"
			:loading="getLoadingAction"
			@close="toggleModalArchivo"
			@aceptar="subirArchivos"
		></BaseModalArchivo>
		<AgregarPersonal
			ref="modalAgregar"
			v-model="personalModal"
			:editar="editar"
			:loading="getLoadingAction"
			@guardar="onCrear"
			@editar="onEditar"
		></AgregarPersonal>
		<BaseModalRestablecerContrasenia
			ref="modalRestablecer"
			:loading="getLoadingAction"
			:descripcion="descripcionModalRestablecer"
			@guardar="onRestablecerContra"
			@close="limpiarModalRestablecer"
		></BaseModalRestablecerContrasenia>
		<BaseTabla
			ref="table"
			:campos="campos"
			:elementos="personal"
			:pagina-actual="paginaActual"
			:loading="getLoading"
			:elemento="elemento"
			tipo="selectable"
			:filtro="filter"
			actions
			sin-detalle
			@cambiarPagina="cambiarPagina"
		>
			<template slot="action" slot-scope="{ item }">
				<div
					v-puede="[roles.Administrador]"
					style="text-align:right;"
					@click.stop
				>
					<i
						class="icon iconAction users alternate"
						title="Aspirantes asociados"
						@click="clickAspirantes(item)"
					></i>
					<i
						class="icon iconAction sync alternate"
						title="Restablecer Contraseña"
						@click="clickContrasenia(item)"
					></i>
					<i
						class="icon iconAction edit"
						title="Editar"
						@click="clickEditar(item)"
					></i>
					<i
						class="icon iconAction trash"
						title="Eliminar"
						@click="clickEliminar(item)"
					></i>
				</div>
			</template>
			<template slot="EMPTY">Sin personal registrado</template>
			<template slot="EMPTY_FILTER">Sin registros para mostrar.</template>
		</BaseTabla>
	</BaseContenedor>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';
import Notification from '@utils/notification';
import Rols from '@constants/roles';
import AgregarPersonal from './agregar-personal.vue';
export default {
	page: {
		title: 'Personal',
		meta: [{ name: 'description', content: 'The Personal page.' }]
	},
	components: {
		AgregarPersonal
	},
	data: function() {
		return {
			paginaActual: 1,
			elemento: null,
			files: [],
			campos: {
				clavePersonal: { nombre: 'Clave personal', class: 'three wide' },
				nombreCompleto: { nombre: 'Nombre completo', class: 'five wide' },
				curp: { nombre: 'CURP', class: 'three wide' },
				correoElectronico: { nombre: 'Correo electrónico', class: 'five wide' }
			},
			filter: '',
			roles: Rols,
			editar: false,
			personalModal: {},
			personalSeleccionado: '',
			descripcionModalRestablecer: '',
			asignarAspirantes: false
		};
	},
	computed: {
		...mapGetters('personal', [
			'getPersonal',
			'getPersona',
			'getLoading',
			'getLoadingAction'
		]),
		...mapGetters('oidc', [
			'oidcIsAuthenticated',
			'oidcUser',
			'oidcIsAuthenticated',
			'oidcAuthenticationIsChecked',
			'oidcUser',
			'oidcIdToken',
			'oidcIdTokenExp'
		]),
		...mapGetters('plantillas', ['getPlantillas']),
		plantilla: function() {
			return this.getPlantillas.CAT_PERSONAL;
		},
		plantillaAsignarAspirantes: function() {
			return this.getPlantillas.CAT_PERSONAL_ASPIRANTES_V2;
		},
		personal: function() {
			return this.getPersonal.map(
				({
					plantel,
					clavePersonal,
					nombreCompleto,
					curp,
					rol,
					bloqueado,
					correoElectronico
				}) => ({
					plantel,
					clavePersonal,
					nombreCompleto,
					curp,
					rol,
					bloqueado,
					correoElectronico
				})
			);
		}
	},
	watch: {
		filter: function(value) {
			this.$refs.table.ocultarElemento();
			if (this.paginaActual !== 1) this.paginaActual = 1;
		},
		getLoadingAction: function(value, old) {
			this.$confirm(null, value);
		}
	},
	mounted() {
		this.establecerTitulo('Personal');
		this.establecerUrlAtras('/catalogos');
		this.inicializar();
	},
	methods: {
		...mapActions('personal', [
			'inicializar',
			'establecerPersona',
			'establecerFiltro',
			'eliminarTodos',
			'subirArchivoCsv',
			'crearPersonal',
			'editarPersonal',
			'eliminarPersonal',
			'restablecerContraseniaPersonal',
			'subirAspirantesPersonalCsv',
			'eliminarTodosAspirantesPersonal'
		]),
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		toggleModalArchivo() {
			this.$refs.table.ocultarElemento();
			this.$refs['modal-archivo'].toggle();
		},
		closeModalArchivo() {
			this.$refs['modal-archivo'].close();
		},
		subirArchivos() {
			if (this.files.length > 0) {
				this.cambiarPagina(1);
				if (this.asignarAspirantes) {
					this.subirAspirantesPersonalCsv({
						archivos: this.files[0],
						onComplete: () => {
							Notification('info', 'Procesando información');
							this.closeModalArchivo();
						}
					});
				} else {
					this.subirArchivoCsv({
						archivos: this.files[0],
						onComplete: () => {
							Notification('info', 'Procesando información');
							this.closeModalArchivo();
							setTimeout(() => this.inicializar(), 2000);
						}
					});
				}

				Vue.set(this, 'files', []);
			}
		},
		cambiarPagina(paginaActual) {
			this.paginaActual = paginaActual;
		},
		onEliminar() {
			this.$refs.table.ocultarElemento();
			this.$confirm({
				title: 'Eliminar Personal',
				message: '¿Desea eliminar al personal?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarTodos({
						onComplete: () => {
							closeModal();
							Notification('success', '¡Personal eliminado con éxito!');
						},
						onError: () =>
							Notification('error', 'Error al eliminar el personal')
					});
					setTimeout(() => this.inicializar(), 2000);
				},
				callbackCancelar: () => {}
			});
		},
		clickAspirantes(personal) {
			this.$router.push(
				`/catalogos/personal/aspirantes/${personal.clavePersonal}`
			);
		},
		toggleModalAgregar() {
			this.editar = false;
			this.$refs.modalAgregar.toggle();
		},
		onCrear() {
			this.crearPersonal({
				params: this.personalModal,
				onComplete: () => {
					this.$refs.modalAgregar.close();
					Notification('success', '¡Personal creado con éxito!');
					setTimeout(() => this.inicializar(), 1000);
				}
			});
		},
		clickEditar(personal) {
			this.establecerPersona(personal);
			this.editar = true;
			this.$refs.modalAgregar.toggle();
		},
		onEditar() {
			this.editarPersonal({
				clave: this.personalModal.clavePersonal,
				params: this.personalModal,
				onComplete: () => {
					this.$refs.modalAgregar.close();
					Notification('success', '¡Personal modificado con éxito!');
					setTimeout(() => this.inicializar(), 1000);
				}
			});
		},
		clickEliminar(personal) {
			this.$confirm({
				title: 'Eliminar personal',
				message: '¿Desea eliminar el personal seleccionado?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarPersonal({
						clave: personal.clavePersonal,
						onComplete: () => {
							closeModal();
							Notification('success', '¡Personal eliminado con éxito!');
						}
					});
					setTimeout(() => this.inicializar(), 1000);
				},
				callbackCancelar: () => {}
			});
		},
		clickContrasenia(item) {
			this.personalSeleccionado = item.clavePersonal;
			this.descripcionModalRestablecer = `${item.clavePersonal} - ${item.nombreCompleto}`;
			this.$refs.modalRestablecer.toggle();
		},
		limpiarModalRestablecer() {
			this.personalSeleccionado = '';
			this.descripcionModalRestablecer = '';
		},
		onRestablecerContra(contra) {
			this.restablecerContraseniaPersonal({
				clave: this.personalSeleccionado,
				params: { contrasenia: contra },
				onComplete: () => {
					this.$refs.modalRestablecer.close();
					Notification('success', '¡Contraseña restablecida con éxito!');
					setTimeout(() => this.inicializar(), 1000);
				}
			});
		},
		clickImportar() {
			this.asignarAspirantes = false;
			this.toggleModalArchivo();
		},
		clickAsignarAspirantes() {
			this.asignarAspirantes = true;
			this.toggleModalArchivo();
		},
		clickEliminarTodosAspirantesPersonal() {
			this.$confirm({
				title: 'Desasociar todos los aspirantes',
				message: '¿Desea desasociar todos los aspirantes al personal?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarTodosAspirantesPersonal({
						onComplete: () => {
							closeModal();
							Notification('success', '¡Aspirantes desasociados con éxito!');
						}
					});
					// setTimeout(() => this.inicializar(), 1000);
				},
				callbackCancelar: () => {}
			});
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
</style>
